<script lang="ts">
	export let valid:boolean = null;
	export let touched:boolean = false;
</script>

<!--don't show a icon if validation was never checked before, e.g. on init -->
{#if valid != null}
	{#if !valid  && touched}
	<div class="icon-invalid" >
		<svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none">
			<path d="M9.73802 1.96274L1.26802 16.1027C1.09339 16.4052 1.00099 16.748 1.00001 17.0973C0.99903 17.4465 1.08951 17.7899 1.26245 18.0933C1.43538 18.3967 1.68474 18.6495 1.98573 18.8266C2.28671 19.0037 2.62882 19.0989 2.97802 19.1027H19.918C20.2672 19.0989 20.6093 19.0037 20.9103 18.8266C21.2113 18.6495 21.4607 18.3967 21.6336 18.0933C21.8065 17.7899 21.897 17.4465 21.896 17.0973C21.8951 16.748 21.8027 16.4052 21.628 16.1027L13.158 1.96274C12.9797 1.66885 12.7287 1.42586 12.4292 1.25723C12.1297 1.08859 11.7918 1 11.448 1C11.1043 1 10.7663 1.08859 10.4668 1.25723C10.1673 1.42586 9.91629 1.66885 9.73802 1.96274Z" stroke="#39BCAE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M11.4482 7.10272V11.1027" stroke="#39BCAE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M11.4482 15.1027H11.4582" stroke="#39BCAE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	</div>
	{/if}
	{#if valid  && touched}
	<div class="icon-valid">
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
			<path d="M20 9.63143V10.5054C19.9988 12.554 19.3355 14.5474 18.1089 16.1882C16.8823 17.829 15.1581 19.0293 13.1936 19.6101C11.2291 20.191 9.12939 20.1212 7.20774 19.4113C5.2861 18.7013 3.64542 17.3892 2.53041 15.6706C1.4154 13.9521 0.885802 11.9191 1.02059 9.87493C1.15538 7.83077 1.94735 5.88495 3.27837 4.32766C4.60938 2.77037 6.40814 1.68505 8.40638 1.23358C10.4046 0.782102 12.4953 0.988658 14.3665 1.82244" stroke="#474747" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M19.9999 2.90543L10.4999 12.4149L7.6499 9.56493" stroke="#474747" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	</div>
	{/if}
{/if}
<style lang="scss">

</style>
